module.exports = __webpack_public_path__ + "media/images/icn-loc-small-1bbd319acb42f2c39533d56adc03d7a9.png";